declare global {
  interface Window {
    grecaptcha: {
      ready: (cb: () => void) => void;
      execute: (
        siteKey: string,
        options: { action: string },
      ) => Promise<string>;
    };
  }
}

const SITE_KEY = process.env['NX_PUBLIC_RECAPTCHA_SITE_KEY'] || '';

let scriptLoadPromise: Promise<void> | null = null;

function loadRecaptchaScript(): Promise<void> {
  if (scriptLoadPromise) {
    return scriptLoadPromise;
  }

  scriptLoadPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA script'));
    document.head.appendChild(script);
  });

  return scriptLoadPromise;
}

import { useState, useEffect, useCallback } from 'react';

export const useRecaptcha = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!SITE_KEY) {
      return;
    }

    loadRecaptchaScript()
      .then(() => {
        window.grecaptcha.ready(() => {
          setIsReady(true);
        });
      })
      .catch((err) => {
        console.warn('reCAPTCHA script failed to load:', err);
      });
  }, []);

  const executeRecaptcha = useCallback(
    async (action: string): Promise<string | null> => {
      if (!SITE_KEY) {
        return null;
      }

      try {
        await loadRecaptchaScript();
        const token = await window.grecaptcha.execute(SITE_KEY, { action });
        return token;
      } catch (err) {
        console.warn('reCAPTCHA execution failed:', err);
        return null;
      }
    },
    [],
  );

  return { executeRecaptcha, isReady };
};
